import { Controller, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import FormFooter from '../../../shared/FormFooter'
import Radio from '@/components/Radio'

interface AccountFormTypes {
  type: string
}

const NewOwnershipType = () => {
  const nav = useNavigate()
  const { t } = useTranslation()

  const { control, handleSubmit } = useForm<AccountFormTypes>({
    defaultValues: {
      type: 'joint',
    },
  })

  const onSubmit = handleSubmit((data) => {
    switch (data.type) {
      case 'joint':
        nav('/dashboard/ownership-types/new/joint')
        break
      case 'trust':
        nav('/dashboard/ownership-types/new/trust')
        break
      case 'entity':
        nav('/dashboard/ownership-types/new/entity')
        break
    }
  })

  return (
    <div className="p-6 xl:p-0">
      <div className="w-full max-w-2xl mx-auto">
        <h1 className="mb-6 text-2xl font-bold text-content-black">
          {t('common:ownershipType')}
        </h1>
        <p className="mb-6 text-16 text-content-black">
          Select the type of ownership account you would like to create.
        </p>
        <form onSubmit={onSubmit}>
          <div className="mb-6">
            <p className="mb-2 text-16 text-content-black">
              {t('common:ownershipType')}
            </p>
            <Controller
              name="type"
              control={control}
              render={({ field, fieldState }) => (
                <div
                  className={`flex flex-col gap-px ${
                    fieldState.error && 'border border-alert'
                  }`}
                >
                  <Radio
                    {...field}
                    value="joint"
                    label={t('common:joint')}
                    checked={field.value === 'joint'}
                  />
                  <Radio
                    {...field}
                    value="trust"
                    label={t('common:trust')}
                    checked={field.value === 'trust'}
                  />
                  <Radio
                    {...field}
                    value="entity"
                    label={t('common:entity')}
                    checked={field.value === 'entity'}
                  />
                </div>
              )}
            />
          </div>
          <FormFooter
            submitFunc={onSubmit}
            backLocation="/dashboard/ownership-types"
          />
        </form>
      </div>
    </div>
  )
}

export default NewOwnershipType
